import * as Edge from './Edges';

export const edgeTypes = {
  addButton: Edge.Condition,
};
